import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from "./index.module.scss"
import WrapperContent from "../../../components/shared/WrapperContent";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CloseIcon from "../../../components/shared/icons/CloseIcon";
import InputCustom from "../../../components/shared/forms/input-custom";
import CardIcon from "../../../components/shared/icons/CardIcon";
import AvatarCameraIcon from "../../../components/shared/icons/AvatarCameraIcon";
import cn from 'classnames';
import Loading from '../../../components/shared/Loading/Loading';
import { Driver, File, Order } from '../../../services';
import { toast } from 'react-toastify';
import { requestErrorDisplay } from '../../../utils';
import { useSelector } from 'react-redux';
import SelectCustom from '../../../components/shared/forms/select-custom';
import ArrowRightRotateIcon from '../../../components/shared/icons/ArrowRightRotateIcon';

const CarsCreatePage = () => {
  const { t, i18n } = useTranslation();
  const { user } = useSelector(state => state);
  const [searchParams] = useSearchParams()
  const navigate = useNavigate();
  const carsUrl = "/cars"
  const backUrl = searchParams.get("redirectUrl") ? searchParams.get("redirectUrl") + "?open=1" : carsUrl
  const [isLoading, setLoading] = useState(false);
  const [loadingTypes, setLoadingTypes] = useState([]);
  const [types, setTypes] = useState([]);

  // Form data
  const [carModel, setCarModel] = useState("");
  const [carNumber, setNumberCar] = useState("");
  const [trailerModel, setTrailerModel] = useState("");
  const [trailerNumber, setTrailerNumber] = useState("");
  const [vehicleType, setVehicleType] = useState(null);
  const [loadingType, setTypeLoading] = useState(null);
  const [carIdPhoto, setCarIdPhoto] = useState(null);
  const [carIdTrailerPhoto, setCarIdTrailerPhoto] = useState(null);

  const [errors, setErrors] = useState({
    carModel: "",
    carNumber: "",
    trailerModel: "",
    trailerNumber: "",
    vehicleType: "",
    carIdPhoto: "",
    carIdTrailerPhoto: "",
  });

  const getDefaultData = async () => {
    // await Driver.getVehicleLoadingTypes()
    await Order.getLoadingTypesDisc(i18n.language)
      .then(response => {
        setLoadingTypes(response.data);
      })
      .catch(error => {
        requestErrorDisplay(error)
      });

    // await Driver.getVehicleTypes()
    await Order.getTypes()
      .then(response => {
        setTypes(response.data);
      })
      .catch(error => {
        requestErrorDisplay(error)
      });
  }

  const validateFormatData = () => {
    const newErrors = {
      carModel: "",
      carNumber: "",
      trailerModel: "",
      trailerNumber: "",
      vehicleType: "",
      carIdPhoto: "",
      carIdTrailerPhoto: "",
    };

    let isValid = true;

    if (!carModel.trim()) {
      newErrors.carModel = t('carsCreatePage.validation.invalidCarModel');
      isValid = false;
    }

    if (!carNumber.trim()) {
      newErrors.carNumber = t('carsCreatePage.validation.invalidCarNumber');
      isValid = false;
    }

    if (!trailerModel.trim()) {
      newErrors.trailerModel = t('carsCreatePage.validation.invalidTrailerModel');
      isValid = false;
    }

    if (!trailerNumber.trim()) {
      newErrors.trailerNumber = t('carsCreatePage.validation.invalidTrailerNumber');
      isValid = false;
    }

    if (!vehicleType) {
      newErrors.vehicleType = t('carsCreatePage.validation.invalidVehicleType');
      isValid = false;
    }

    if (!carIdPhoto) {
      newErrors.carIdPhoto = t('carsCreatePage.validation.invalidCarRegCert');
      isValid = false;
    }

    if (!carIdTrailerPhoto) {
      newErrors.carIdTrailerPhoto = t('carsCreatePage.validation.invalidTrailerRegCert');
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) {
      Object.values(newErrors).forEach((error) => {
        if (error) {
          toast.error(error);
        }
      });
    }

    return isValid;
  }

  const onSubmit = () => {
    if (!validateFormatData()) {
      return false;
    }
    setLoading(true)

    const data = {
      carModel,
      carNumber,
      trailerNumber,
      trailerModel: trailerModel,
      loadingTypeId: loadingType?.id,
      vehicleTypeId: vehicleType?.id,
    }

    Driver.createVehicleByExpeditor(data)
      .then(res => res.data)
      .then(async data => {
        const vehicleId = data.id
        if (carIdPhoto) {
          await uploadFile({
            vehicleId,
            side: 0,
            file: carIdPhoto,
            type: 4 // Тех. паспорт
          })
        }
        if (carIdTrailerPhoto) {
          await uploadFile({
            vehicleId,
            side: 0,
            file: carIdTrailerPhoto,
            type: 7 //  фото тех паспорта прицепа
          })
        }
        toast.success(t('carsCreatePage.toast.createSuccess'));
        // toast.info("Автомобиль будет доступен для назначения в заявки после того как пройдет модерацию", { delay: 2000 }) // Key needed: carsCreatePage.toast.moderationInfo
        navigate(backUrl)
      })
      .catch(error => {
        requestErrorDisplay(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const uploadFile = (data) => {
    const Formdata = new FormData()
    for (const dataKey in data) {
      Formdata.append(dataKey, data[dataKey])
    }
    return File.addVehicleFile(Formdata)
  }

  useEffect(() => {
    getDefaultData()
  }, [i18n.language])

  return (
    <WrapperContent>
      <div className={style.wrapper}>
        <h1 className={style.title}>{t('carsCreatePage.title')}</h1>
        <div className={style.content}>
          <div className={style.field_col_2}>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.carModel.label')} *</span>
              <InputCustom
                placeholder={t('carsCreatePage.carModel.placeholder')}
                defaultValue={carModel}
                onChangeValue={(value) => {
                  setCarModel(value);
                  if (errors.carModel) setErrors((prev) => ({ ...prev, carModel: "" }));
                }}
                className={errors.carModel ? style.input_error : ""}
                errorText={errors?.carModel}
              />
            </div>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.carNumber.label')} *</span>
              <InputCustom
                placeholder={t('carsCreatePage.carNumber.placeholder')}
                defaultValue={carNumber}
                onChangeValue={(value) => {
                  setNumberCar(value);
                  if (errors.carNumber) setErrors((prev) => ({ ...prev, carNumber: "" }));
                }}
                className={errors.carNumber ? style.input_error : ""}
                errorText={errors?.carNumber}
              />
            </div>
          </div>
          <div className={style.field_col_2}>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.trailerModel.label')} *</span>
              <InputCustom
                placeholder={t('carsCreatePage.trailerModel.placeholder')}
                defaultValue={trailerModel}
                onChangeValue={(value) => {
                  setTrailerModel(value);
                  if (errors.trailerModel) setErrors((prev) => ({ ...prev, trailerModel: "" }));
                }}
                className={errors.trailerModel ? style.input_error : ""}
                errorText={errors?.trailerModel}
              />
            </div>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.trailerNumber.label')} *</span>
              <InputCustom
                placeholder={t('carsCreatePage.trailerNumber.placeholder')}
                defaultValue={trailerNumber}
                onChangeValue={(value) => {
                  setTrailerNumber(value);
                  if (errors.trailerNumber) setErrors((prev) => ({ ...prev, trailerNumber: "" }));
                }}
                className={errors.trailerNumber ? style.input_error : ""}
                errorText={errors?.trailerNumber}
              />
            </div>
          </div>
          <div className={style.field_col_2}>
            <div className={style.field} style={{ position: "relative", zIndex: "2" }}>
              <span className={style.field_label}>{t('carsCreatePage.vehicleType.label')} *</span>
              <SelectCustom
                placeholder={t('carsCreatePage.vehicleType.placeholder')}
                options={types}
                defaultValue={vehicleType}
                returnObject
                bgGray
                onSubmit={(value) => {
                  setVehicleType(value);
                  if (errors.vehicleType) setErrors((prev) => ({ ...prev, vehicleType: "" }));
                }}
              />
              {errors.vehicleType && <p className={style.error_message}>{errors.vehicleType}</p>}
            </div>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.loadingType.label')}</span>
              <SelectCustom
                placeholder={t('carsCreatePage.loadingType.placeholder')}
                options={loadingTypes}
                defaultValue={loadingType}
                returnObject
                bgGray
                onSubmit={(value) => {
                  setTypeLoading(value);
                  if (errors.loadingType) setErrors((prev) => ({ ...prev, loadingType: "" }));
                }}
              />
              {errors.loadingType && <p className={style.error_message}>{errors.loadingType}</p>}
            </div>
          </div>
          <div className={style.field_col_2}>
            {/* <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.carPhoto.label')} *</span>
                <label className={cn(style.field_upload, { [style.field_upload_error]: errors.carPhoto })}>
                  <AvatarCameraIcon fill={"#C3C5CA"} />
                  <span>{carPhoto?.name || t('carsCreatePage.carPhoto.placeholder')}</span>
                  <input
                    type="file"
                    onChange={(event) => {
                      setCarPhoto(event.target.files[0]);
                      if (errors.carPhoto) setErrors((prev) => ({ ...prev, carPhoto: "" }));
                    }}
                  />
                </label>
                {errors.carPhoto && <p className={style.error_message}>{errors.carPhoto}</p>}
            </div> */}
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.trailerRegCert.label')} *</span>
                <label className={cn(style.field_upload, { [style.field_upload_error]: errors.carIdTrailerPhoto })}>
                  <AvatarCameraIcon fill={"#C3C5CA"} />
                  <span className={style.file_name}>{carIdTrailerPhoto?.name || t('carsCreatePage.trailerRegCert.placeholder')}</span>
                  <input
                    type="file"
                    onChange={(event) => {
                      setCarIdTrailerPhoto(event.target.files[0]);
                      if (errors.carIdTrailerPhoto) setErrors((prev) => ({ ...prev, carIdTrailerPhoto: "" }));
                    }}
                  />
                </label>
                {errors.carIdTrailerPhoto && <p className={style.error_message}>{errors.carIdTrailerPhoto}</p>}
            </div>
            <div className={style.field}>
              <span className={style.field_label}>{t('carsCreatePage.carRegCert.label')} *</span>
                <label className={cn(style.field_upload, { [style.field_upload_error]: errors.carIdPhoto })}>
                  <AvatarCameraIcon fill={"#C3C5CA"} />
                  <span className={style.file_name}>{carIdPhoto?.name || t('carsCreatePage.carRegCert.placeholder')}</span>
                  <input
                    type="file"
                    onChange={(event) => {
                      setCarIdPhoto(event.target.files[0]);
                      if (errors.carIdPhoto) setErrors((prev) => ({ ...prev, carIdPhoto: "" }));
                    }}
                  />
                </label>
                {errors.carIdPhoto && <p className={style.error_message}>{errors.carIdPhoto}</p>}
            </div>
          </div>

          <div className={style.create_button_container}>
            <Link to={backUrl} className={style.buttonCancel}>
              {t('carsCreatePage.buttons.cancel')}
            </Link>
            <button
              className={cn(style.button_upload, { [style.button_upload_loading]: isLoading })}
              onClick={() => onSubmit()}
              disabled={isLoading}
            >
              {!isLoading && <span>{t('carsCreatePage.buttons.confirm')}</span>}
              {isLoading && <Loading inBlock marginBottom={0} />}
            </button>
        </div>

        </div>
        <Link to={backUrl} className={style.buttonClose}>
          <CloseIcon />
        </Link>
      </div>
    </WrapperContent>
  );
};

export default CarsCreatePage;
